import React from 'react';
import ReactModal from 'react-modal';
import { getDate } from '../../../../helpers/dateHelper';
import { Coupon, CouponTypes } from '../../../../types/coupons';
import { AppButton } from '../../ctaButton/button';
import './style.css';
import { Charity } from '../../../../types/charities';
import { Box } from '@material-ui/core';
interface Props {
  charity: Charity;
  closeModal: () => void;
  showModal: boolean;
  couponStatusType: 'server' | 'client';
}

export const CharityViewModal = ({
  charity,
  closeModal,
  showModal,
  couponStatusType,
}: Props) => {
  return (
    <div>
      {charity && (
        <ReactModal
          onRequestClose={closeModal}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          appElement={document.getElementById('root')}
          onClose={closeModal}
          isOpen={showModal}
          contentLabel='Inline Styles Modal Example'
          className='globalModalWrapper'
          style={{
            overlay: {
              backgroundColor: 'rgba(9, 16, 29, 0.6)',
              zIndex: 10,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
            },
          }}
        >
          <div className='couponModalContentWrapper'>
            <div className='modalHeader'>
              <span>View Charity details</span>
            </div>
            <div>
              {charity.image && (
                <Box className='image-box'>
                  <img
                    src={`${process.env.REACT_APP_AWS_S3_URL}/${charity.image}`}
                    alt={`${charity.name} charity`}
                  />
                </Box>
              )}
            </div>
            <div className='modalBody modalBody_view'>
              <div className='side side_left'>
                <CouponDataBlock
                  title='Charity'
                  allowWhitespaces={true}
                  content={charity.name}
                />
                <CouponDataBlock
                  title='Charity Page'
                  content={charity.isActiveOnCharityPage ? 'Show' : 'Hide'}
                />
                <CouponDataBlock
                  title='Checkout Page'
                  content={charity.isActiveOnCheckoutPage ? 'Show' : 'Hide'}
                />
                {charity.charityUrl && (
                  <CouponDataBlock
                    title='Charity Page Url'
                    allowWhitespaces={true}
                    content={charity.charityUrl}
                  />
                )}
                {charity.landingUrl && (
                  <CouponDataBlock
                    title='Landing Page Url'
                    allowWhitespaces={true}
                    content={charity.landingUrl}
                  />
                )}
                {charity.landingTag && (
                  <CouponDataBlock
                    title='Landing Tag'
                    allowWhitespaces={true}
                    content={charity.landingTag}
                  />
                )}
                {charity.value && (
                  <CouponDataBlock
                    title='Ticket Selector Value'
                    allowWhitespaces={true}
                    content={charity.value}
                  />
                )}
              </div>
              <div className='side side_right'>
                {/* <CouponDataBlock
                  type='inline'
                  title='Date of use'
                  content={
                    charity.dateOfUse
                      ? getDate(new Date(charity.dateOfUse))
                      : '---'
                  }
                /> */}
              </div>
            </div>
            <div className='descriptionRow'>
              <CouponDataBlock
                title='Description'
                content={charity.description}
              />
            </div>
            <div className='modalFooter'>
              <AppButton onClick={closeModal} size='long' text='Ok' />
            </div>
          </div>
        </ReactModal>
      )}
    </div>
  );
};

interface DataField {
  type?: 'inline' | 'default';
  title: string;
  content: string;
  allowWhitespaces?: boolean;
}
const CouponDataBlock = ({
  type,
  title,
  content,
  allowWhitespaces,
}: DataField) => (
  <div className={type === 'inline' ? 'row inline' : 'row'}>
    <p className='fieldHeader'>{title}</p>
    <p
      className={allowWhitespaces ? 'fieldData allowWhitespaces' : 'fieldData'}
    >
      <span>{content}</span>
    </p>
  </div>
);
